import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './lab-date-pickers-to-mui-x.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
